<template>
  <div class="sp-template">
    <div class="h-title">货物测量</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <el-select v-model="queryForm.productIds" filterable clearable multiple placeholder="选择渠道">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model="queryForm.customerIds" filterable clearable multiple placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="开始日期">
              <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model.lazy="orderIds" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(40305)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(40305)" size="small" @click="reset()">清 空</el-button>
            <el-button v-if="in_configs(40306) && queryForm.status == 1" size="small" @click="downloadDoneMeasureData">导出</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.status" @tab-click="searchTask">
					<el-tab-pane v-if="in_configs(40303)" label="待处理" name="0"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40304)" label="完成" name="1"></el-tab-pane>
				</el-tabs>
        <div class="button-groups">
          <el-button v-show="in_configs(40302) && queryForm.status == 0" size="small" @click="batchMeasure()">批量测量</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column label="仓库">
          <template slot-scope="scope">
            {{warehouseMap[scope.row.warehouseCode]}}
          </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.product]}}
          </template>
        </el-table-column>
        <el-table-column label="客户单号">
          <template slot-scope="scope">
            <div v-if="scope.row.refNumber">
              <p v-for="(item, index) in formatRefNumber(scope.row.refNumber)" :key="index">{{item}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalCarton" label="预报箱数"></el-table-column>
        <el-table-column prop="arrivaledCarton" label="已到货箱数"></el-table-column>
        <el-table-column prop="doneCarton" label="已测量箱数"></el-table-column>
        <el-table-column prop="createAt" label="预报时间"></el-table-column>
        <el-table-column v-if=" queryForm.status == 1 " prop="operator" label="操作人"></el-table-column>
        <el-table-column v-if=" queryForm.status == 1 " prop="operateAt" label="操作时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="in_configs(40301) && queryForm.status == 0 && scope.row.totalCarton!=scope.row.doneCarton " size="mini" type="text" @click="handleEditAndView(true,scope.$index, scope.row,0)">测量</el-button>
            <el-button v-if="queryForm.status == 1" size="mini" type="text" @click="handleEditAndView(false,scope.$index, scope.row,1)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
    </el-card>
    <!-- 批量测量 -->
    <el-dialog title="批量测量" :visible.sync="batchMeasureDialog" :show-close='false' width="500px">
      <div class="inline-flex">
        <div class="text">仓库：</div>
        <div class="item">
          <el-select v-model.lazy="batchMeasureWarehouse" size="small">
            <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </div>
      </div>
      <form action="BatchFileUploadServlet" enctype="multipart/form-data" name="batchFileUploadForm" class="el-input--small">
        <input type="file" ref="batchDocFile" accept=".xlsx,.xls" id="batchDocFile" style="display: none;" onchange="document.batchFileUploadForm.batchFilePath.value = this.value" />
        <input type="text" class="el-input__inner" style="display: none; width:200px;" name="batchFilePath" id="batchFilePath" readonly />

        <div class="inline-flex">
          <div class="text">测量模板</div>
          <div class="item">
            <a href="../../../../static/template/batch_measure.xlsx" download="batch_measure.xlsx" target="_blank" class="download-icon">
              点击下载
            </a>
          </div>
        </div>
        <div class="inline-flex">
          <div class="text">上传测量数据</div>
          <div class="item">
            <input type="button" class="el-button el-button--small" value="点击上传" onclick="document.batchFileUploadForm.batchDocFile.click()" />
          </div>
        </div>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelBatchMeasure()">取 消</el-button>
        <el-button size="small" type="primary" @click="batchMeasureDone()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 测量弹窗 -->
    <el-dialog title="测量内容" :visible.sync="dialogTableVisible" :show-close='!isEdit' width="1000px" class="measure-goods__dialog">
      <el-form :model="measureData" size="small" label-width="100px" label-position="left">
        <el-form-item label="订单号: ">{{measureData.orderId}}</el-form-item>
        <el-form-item label="预报箱数: ">{{measureData.totalCarton}}</el-form-item>
        <el-form-item label="可测量箱数: ">{{measureData.needMeasureCarton}}</el-form-item>
        <el-form-item label="规格: " v-show="isEdit&&uploadOrAdd==0">
          <el-radio-group v-model="sameSpec">
            <el-radio :label="0">相同</el-radio>
            <el-radio :label="1">不相同</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="填写方式" v-show="isEdit">
          <el-radio-group v-model="uploadOrAdd">
            <el-radio :label="0">页面填写</el-radio>
            <el-radio :label="1">上传</el-radio>
          </el-radio-group>
        </el-form-item>
        <input v-show="!isEdit" type="button" class="el-button el-button--small" value="下载测量数据" @click="downMeasureData()" />
      </el-form>
      <form v-show="isEdit && uploadOrAdd==1" action="FileUploadServlet" enctype="multipart/form-data" name="fileUploadForm">
        <input type="file" ref="docFile" id="docFile" accept=".xlsx,.xls" style="display: none;" onchange="document.fileUploadForm.filePath.value = this.value" />
        <div class="inline-flex">
          <div class="text">测量模板</div>
          <div class="item">
            <a href="../../../../static/template/carton_measure.xlsx" download="carton_measure.xlsx" target="_blank" class="download-icon">点击下载</a>
          </div>
        </div>
        <div class="inline-flex">
          <div class="text">上传测量数据</div>
          <div class="item">
            <input type="button" class="el-button el-button--small" value="点击上传" onclick="document.fileUploadForm.docFile.click()" />
            <!-- <input type="text" class="el-input__inner" style="display: none; width:200px;" name="filePath" id="filePath" readonly /> -->
            <el-input name="filePath" id="filePath" readonly size="small"></el-input>
          </div>
        </div>
      </form>
      <!-- 规格相同 -->
      <el-form v-show="uploadOrAdd==0 && sameSpec==0 && isEdit">
        <el-input type="number" min="0" size="small" v-model="singleMeasureData.length" placeholder="长" style="width:20%">
          <template slot="append">CM</template>
        </el-input>
        <el-input type="number" min="0" size="small" v-model="singleMeasureData.width" placeholder="宽" style="width:20%">
          <template slot="append">CM</template>
        </el-input>
        <el-input type="number" min="0" size="small" v-model="singleMeasureData.height" placeholder="高" style="width:20%">
          <template slot="append">CM</template>
        </el-input>
        <el-input type="number" min="0" size="small" v-model="singleMeasureData.weight" placeholder="重量" style="width:20%">
          <template slot="append">KG</template>
        </el-input>
      </el-form>
      <!-- 规格不相同 -->
      <el-table :data="measureData.details" v-if="uploadOrAdd==0 && sameSpec==1" border style="width:100%; margin-top: 20px;">
        <el-table-column property="cartonNumber" label="箱号"></el-table-column>
        <el-table-column label="长(cm)">
          <template slot-scope="scope">
            <span v-show="!isEdit">{{scope.row.measureData.length}}</span>
            <el-input type="number" min="0" size="small" v-show="isEdit" v-model="scope.row.measureData.length" placeholder="长" style="width:70%"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="宽(cm)">
          <template slot-scope="scope">
            <span v-show="!isEdit">{{scope.row.measureData.width}}</span>
            <el-input type="number" min="0" size="small" v-show="isEdit" v-model="scope.row.measureData.width" placeholder="宽" style="width:70%"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="高(cm)">
          <template slot-scope="scope">
            <span v-show="!isEdit">{{scope.row.measureData.height}}</span>
            <el-input type="number" min="0" size="small" v-show="isEdit" v-model="scope.row.measureData.height" placeholder="高" style="width:70%"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="重量(kg)">
          <template slot-scope="scope">
            <span v-show="!isEdit">{{scope.row.measureData.weight}}</span>
            <el-input type="number" min="0" size="small" v-show="isEdit" v-model="scope.row.measureData.weight" placeholder="重量" style="width:70%"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" v-show="isEdit">
        <el-button size="small" @click="cancelMeasure()">取 消</el-button>
        <el-button size="small" type="primary" @click="measureDone()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      orderIds: "",
      queryForm: {
        warehouseIds: [],
        orderIds: [],
        status: 0,
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      },
      //填写还是上传
      uploadOrAdd: 0,
      //规格是否相同
      sameSpec: 0,
      //表单数据
      tableData: [],
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      //弹框数据
      measureData: {
        orderId: "",
        totalCarton: 0,
        details: [
          {
            cartonNumber: "",
            measureData: {
              length: 0,
              width: 0,
              height: 0,
              weight: 0
            }
          }
        ]
      },
      warehouses: [],
      warehouseData: [],
      warehouseMap: {},
      batchMeasureWarehouse: "",
      singleMeasureData: {},
      isEdit: true,
      dialogTableVisible: false,
      batchMeasureDialog: false,
      multipleSelection: [],
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1
      //当前页
    };
  },
  components: {},
  watch: {},
  created() {
    setTimeout(() => {
      this.initData();
    }, 1000);
  },
  computed: {},
  methods: {
    reset() {
      this.queryForm = {
        warehouseIds: [],
        orderIds: [],
        status: 0,
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      };
      this.orderIds = "";
      this.query();
    },
    formatRefNumber(refNumber) {
      let arr = refNumber.split(",");
      arr.forEach((item, index) => {
        if (item === " " || item === ",") {
          arr.splice(index, 1);
        }
      });
      return arr;
    },
    //  下载测量数据
    downMeasureData() {
      let url = '/operation/measure/' + this.measureData.orderId + '/download';
      this.$windowOpen1(url);
    },
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllCustomerName(),
        this.findAllWarehouse(),
        this.findAllChannle()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, warehouseData, channelData) {
          _this.initCustomerData(customerData);
          _this.initWarehouseData(warehouseData);
          _this.initChannelData(channelData);
          _this.query();
        })
      );
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
      _this.warehouses.forEach(a => {
        _this.warehouseMap[a.id] = a.name;
      });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
        {
          withCredentials: true
        }
      );
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
        {
          withCredentials: true
        }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
        {
          withCredentials: true
        }
      );
    },
    //批量上传
    batchMeasure() {
      this.batchMeasureDialog = true;
    },
    cancelBatchMeasure() {
      this.batchMeasureWarehouse = "";
      var file = document.getElementById("batchDocFile");
      file.outerHTML = file.outerHTML;
      file.value = ""; //虽然file的value不能设为有字符的值，但是可以设置为空值
      var fileText = document.getElementById("batchFilePath");
      fileText.value = "";
      this.batchMeasureDialog = false;
    },
    batchMeasureDone() {
      //validate 是否选择文件
      if (this.batchMeasureWarehouse == "") {
        this.$notify.info({
          title: "提示",
          message: "请选择仓库"
        });
        return;
      }
      if (document.getElementById("batchDocFile").files.length == 0) {
        this.$notify.info({
          title: "提示",
          message: "请选择文件"
        });
        return;
      }
      let formdata = new FormData();
      formdata.append(
        "cartonMeasureFile",
        document.getElementById("batchDocFile").files[0]
      );
      this.batchMeasureDialog = false;
      this.$request1({
        method: 'POST',
        url: '/operation/measure/' + this.batchMeasureWarehouse + '/batch',
        data: formdata,
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            setTimeout(() => {
              this.query();
            }, 1500);
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
          var file = document.getElementById("batchDocFile");
          file.outerHTML = file.outerHTML;
          file.value = ""; //虽然file的value不能设为有字符的值，但是可以设置为空值
          var fileText = document.getElementById("batchFilePath");
          fileText.value = "";
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },

    //搜索
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    query() {
      let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      //过滤仓库
      let wlist = [];
      if (this.warehouses != null && this.warehouses.length > 0) {
        if (
          _this.queryForm.warehouseIds &&
          _this.queryForm.warehouseIds.length > 0
        ) {
          wlist = _this.queryForm.warehouseIds;
        } else {
          wlist = this.warehouses.map(a => a.id);
        }
      } else {
        wlist.push("NOT MATCHING");
      }

      this.$request1({
        method: 'post',
        url: '/operation/measure/query',
        withCredentials: true,
        data: {
          orderIds: this.queryForm.orderIds,
          refNumbers: this.queryForm.refNumbers,
          customerIds: this.queryForm.customerIds,
          productIds: this.queryForm.productIds,
          status: this.queryForm.status,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export,
          warehouseIds: wlist
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            this.total = data.total;
            if (this.total > 0) {
              this.tableData = taskData;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            _this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    //编辑
    handleEditAndView(isEdit, index, row, spec) {
      //通过订单号，查询本订单的所有箱号
      console.log(row);
      if (isEdit && row.arrivaledCarton - row.doneCarton == 0) {
        this.$notify.info({
          title: "消息",
          message: "当前订单没有可以测量的箱"
        });
        return;
      }
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/operation/measure/' + row.orderId + '/details/' + isEdit + '',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          this.measureData = {
            orderId: row.orderId,
            totalCarton: row.totalCarton,
            needMeasureCarton: row.arrivaledCarton - row.doneCarton
          };
          if (data.length == 0) {
            this.$notify.info({
              title: "消息",
              message: "当前订单还没到货"
            });
          } else {
            this.dialogTableVisible = true;
            this.measureData.details = data;
          }
        })
        .catch(error => {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
      this.isEdit = isEdit;
      this.sameSpec = spec;
    },
    measureDone() {
      //validate
      let formdata = new FormData();
      if (this.uploadOrAdd == 1) {
        formdata.append(
          "cartonMeasureFile",
          document.getElementById("docFile").files[0]
        );
      }
      let measureDoneData = {};
      measureDoneData.orderId = this.measureData.orderId;
      if (this.uploadOrAdd == 0 && this.sameSpec == 0) {
        console.log(this.singleMeasureData.length == null);
        if (
          this.singleMeasureData.length == null ||
          this.singleMeasureData.width == null ||
          this.singleMeasureData.height == null ||
          this.singleMeasureData.weight == null
        ) {
          this.$notify.error({
            title: "错误",
            message: "请输入长宽高"
          });
          return;
        }
        if (
          this.singleMeasureData.length == 0 ||
          this.singleMeasureData.width == 0 ||
          this.singleMeasureData.height == 0 ||
          this.singleMeasureData.weight == 0
        ) {
          this.$notify.error({
            title: "错误",
            message: "长宽高重量不能为0"
          });
          return;
        }
        measureDoneData.measureData = this.singleMeasureData;
      }
      if (this.uploadOrAdd == 0 && this.sameSpec == 1) {
        let errorMessage = "";
        this.measureData.details.forEach((d, index) => {
          console.log(d);
          if (
            d.measureData.length == "" ||
            d.measureData.width == "" ||
            d.measureData.height == "" ||
            d.measureData.weight == ""
          ) {
            errorMessage =
              errorMessage +
              "箱号：" +
              d.cartonNumber +
              ",长宽高数据不能为空 </br>";
          } else if (
            d.measureData.length == 0 ||
            d.measureData.width == 0 ||
            d.measureData.height == 0 ||
            d.measureData.weight == 0
          ) {
            errorMessage =
              errorMessage +
              "箱号:" +
              d.cartonNumber +
              ",长宽高数据不能为0 <br>";
          }
        });
        if (errorMessage != "") {
          this.$notify.error({
            title: "错误",
            dangerouslyUseHTMLString: true,
            message: errorMessage
          });
          return;
        }
        measureDoneData.itemDetails = this.measureData.details;
      }
      this.dialogTableVisible = false;
      formdata.append("doneForm", JSON.stringify(measureDoneData));
      this.$request1({
        method: 'POST',
        url: '/operation/measure',
        data: formdata,
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.singleMeasureData = {};
            this.measureData = {
              orderId: "",
              totalCarton: 0,
              details: [
                {
                  cartonNumber: "",
                  measureData: { length: 0, width: 0, height: 0, weight: 0 }
                }
              ]
            };
            setTimeout(() => {
              this.query();
            }, 1500);
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    //关闭弹窗
    cancelMeasure() {
      this.dialogTableVisible = false; //
      this.measureData = {};
      this.uploadOrAdd = 0;
      this.sameSpec = 0;
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    downloadDoneMeasureData() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return;
      }
      let orderIds = [];
      this.multipleSelection.forEach((item, index) => {
        orderIds.push(item.orderId);
      });
      this.$request1({
        method: 'POST',
        url: '/operation/measure/download/measuredata',
        headers: { "content-type": "application/json" },
        data: orderIds,
        responseType: "json"
      }).then(res => {
        if (!res.data.success) {
          this.$notify.error({
            title: "错误消息",
            message: res.data.message
          });
          return;
        }
        if (res.data.data) {
          var byteCharacters = atob(res.data.data);

          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          let blob = new Blob([byteArray], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let objectUrl = URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = objectUrl;
          a.download = "已完成测量订单.xlsx";
          a.click();
        } else {
          this.$notify.error({
            title: "提示",
            message: "导出失败"
          });
        }
      });
    }
  }
};
</script> <style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
.inline-flex {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 18px;
  .text {
    width: 100px;
  }
  .item {
    display: flex;
    > :first-child {
      margin-right: 15px;
    }
  }
}
.download-icon {
  color: #409eff;
  &:hover {
    text-decoration: underline;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/orderOperation/measuregoods.vue